import tacklebox from "tacklebox";

import { Pager } from '@/js/Pager.js'



function App() {
    this.name = "Furby"
    this.pager = new Pager();
    this.version = "1.0"
}
App.prototype.getVersion = function () {
    return this.name + "Ver. " + this.version;
};
App.prototype.initialize = function () {
    tacklebox.i(this.getVersion());
};
App.prototype.destroy = function () {
    this.pager.destroy();
};

export { App }